<template>
  <v-menu open-on-hover bottom offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        id="top-report-save"
        class="text-white -color ma-2"
        color="success"
        v-bind="attrs"
        v-on="on"
        :disabled="exportStatus"
      >
        {{ $t("nav_buttons.export") }}
        <v-icon dark right> mdi-table-arrow-right </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-if="checkUserTag('billing_export_csv')"
        @click="getElementById('export-data').click()"
      >
        <v-icon color="green darken-2" left>
          mdi-file-delimited-outline
        </v-icon>
        {{ $t("nav_buttons.csv") }}
      </v-list-item>
      <v-list-item
        @click="getElementById('zipped-reports').click()"
        v-if="checkTag('zipped_reports')"
      >
        <v-icon color="green darken-2" left> mdi-folder-zip-outline</v-icon>
        {{ $t("nav_buttons.zip") }}
      </v-list-item>
      <!-- Export Selection removed by radu -- i dont think that we need this
      <v-list-item
        :disabled="isTopSubmitLoading"
        v-if="
          checkTag('export_selected_documents') &&
          !isTopSubmitLoading &&
          ($store.state.inBillingListingMode ||
            $store.state.inExpenseListingMode) &&
          totalSelectionCount
        "
        id="top-export-selection"
        color="warning"
        @click="getElementById('export-selection').click()"
      >
        <v-icon left> mdi-folder-zip-outline</v-icon>
        {{ $t("nav_buttons.export_selection") }}
      </v-list-item>-->
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: "ExportDropDownButtons",
  props: {
    totalSelectionCount: Number,
  },
  computed: {
    exportStatus() {
      return this.$store.state.exportStatus;
    },
    isTopSubmitLoading() {
      // return true
      return this.$store.state.topSubmitLoading;
    },
  },
};
</script>
